
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c1.864 0 3.399 1.275 3.844 3H29v20H3V6h9.156c.445-1.725 1.98-3 3.844-3zm0 2c-.81 0-1.428.385-1.75 1h3.5c-.322-.615-.94-1-1.75-1zM5 8v9h22V8H5zm11 6a1 1 0 110 2 1 1 0 010-2zM5 19v5h22v-5H5z"}})])
          )
        }
      }
    